import EfNavProduct, { EfNavProductItemProps } from '@elem/ui/ef-nav-product';
import { useRouter } from 'next/router';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import { useNavGoTop } from '../index';

export default function NavProduct() {
    const { locale = '' } = useRouter();
    const IS_US = locale === 'us';
    const dispatch = useProductDispatch();
    const store = useProductStore();
    const nameText: Record<string, string> = {
        en: 'EcoFlow Power Kits 5kVA System',
        de: 'EcoFlow Power Kits 5 kVA Sytem',
    };
    const productText: Record<string, string> = {
        en: 'Product',
        de: 'Überblick',
    };
    const supportText: Record<string, string> = {
        en: 'Support',
        de: 'Unterstützung',
    };
    const specsText: Record<string, string> = {
        en: 'Specs',
        de: 'Spezifikationen',
    };
    let list: EfNavProductItemProps[] = [
        {
            type: 'Product',
            title: productText[locale] || productText.en,
        },
        // {
        //     type: 'Bundles',
        //     title: 'Bundles',
        // },
        {
            type: 'Support',
            title: supportText[locale] || supportText.en,
        },
        {
            type: 'Specs',
            title: specsText[locale] || specsText.en,
        },
        // {
        //     type: 'Media',
        //     title: 'Media',
        // },
    ];
    if (IS_US) {
        list = [
            {
                type: 'Product',
                title: productText[locale] || productText.en,
            },
            {
                type: 'Bundles',
                title: 'Bundles',
            },
            {
                type: 'Support',
                title: supportText[locale] || supportText.en,
            },
            {
                type: 'Specs',
                title: specsText[locale] || specsText.en,
            },
        ];
    }

    let buyItem: any = {
        type: 'BuyNow',
        title: locale === 'de' ? 'Jetzt kaufen' : 'Buy Now',
        href: '',
    };
    if (IS_US) {
        buyItem = {
            type: 'Bundles',
            title: 'Buy Now',
        };
    }
    const { handleGoTop } = useNavGoTop();
    const itemCallback = (item: any) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.type,
        });
        // 切换时划回顶部
        if (locale === 'us') {
            handleGoTop();
        } else {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth',
            });
        }
    };

    return (
        <EfNavProduct
            currentSelectType={store.productTabActive}
            selectType="Product"
            name={nameText[locale] || nameText.en}
            list={list}
            buyItem={buyItem}
            callback={itemCallback}
            buyCallback={itemCallback}
            locale={locale}
        />
    );
}
